// extracted by mini-css-extract-plugin
export default {"container":"textArea_container__5j5gn"};